import type { Subtree } from '../state/types/customer'
import type { ServiceType } from '@modul-connect/shared/utils/services'

export function getServiceList(state: {subtrees: {subtrees: Subtree[]}}) {
  return new ServiceList(state.subtrees.subtrees)
}

export class ServiceList {
  organisations: Subtree[]
  services: Set<ServiceType>
  servicesForOrgs: Record<string, string[]>

  constructor(organisations: Subtree[]) {
    this.services = new Set<ServiceType>(organisations.flatMap(org => org.services) as ServiceType[])
    this.organisations = organisations
    this.servicesForOrgs = Object.fromEntries(
      organisations.map(org => [org.uuid, org.services]) 
    )
  }

  hasService(service: ServiceType) {
    return this.services.has(service)
  }

  organisationsHasService(service: ServiceType): Subtree[] {
    return this.organisations
      .filter(org => org.services.includes(service))
  }

  hasServiceForSelected(selectedOrganisations: string[] | null | undefined, service: ServiceType): boolean {

    if (!selectedOrganisations?.length) {
      return this.services?.has(service) ?? false
    }

    return selectedOrganisations.some(orgId => {

      if (this.servicesForOrgs?.[orgId]?.includes(service)) {
        return true
      }

      const parentOrg = this.organisations?.find(p => 
        p.children?.some(c => c.uuid === orgId)
      )

      return !!parentOrg && !!this.servicesForOrgs?.[parentOrg.uuid]?.includes(service)
    })
  }
}
